// User Functions
export const capFirstLetter = (value) => {
    let name = value.toLowerCase().trim(); 
    return name.charAt(0).toUpperCase() + name.slice(1);
}

export const humanReadableDate = (incDate) => {
    const date = new Date(incDate);
    const formattedDateTime = date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true // For 12-hour format with AM/PM
    });
    return formattedDateTime;
}

export const formatPhoneNo = (value, e) => {

    const actionType = e.nativeEvent.inputType;
    
    if (actionType === 'insertText') {
      value = value.replaceAll('(', '').replaceAll('-', '').replaceAll('.', '').replaceAll(')', '').toString();
      if (value.length === 3) {
        if (value.at(-1) !== '-') {
          value = value + '-';
        }
      } else if (value.length > 3) {
        value = value.substring(0, 3) + '-' + value.substring(3);
        if ( (value.length === 7) && (value.at(-1) !== '-') ) {
          value = value + '-';
        } else if (value.length > 7) {
          value = value.substring(0, 7) + '-' + value.substring(7);
        }
      }
    } else if ( (actionType === 'deleteContentBackward') || (actionType === 'deleteContentForward') ) {
      if (value.toString().at(-1) === '-') {
        const length = value.length - 1;
        value = value.substring(0, length);
      }
    }

    return value;

}

export const parseDayJsDate = (date) => {
  const year = date.$d.getFullYear();
  const month = date.$d.getMonth() + 1;
  const day = date.$d.getDate();

  const hour = date.$H;
  const minute = date.$m;
  
  return `${month}/${day}/${year} ${hour}:${minute}`;
}
